module.exports = "https://cdn.realtymogul.com/static/media/RP_Cumberlandmetro.f2bed105.jpg";